import { t } from "@lingui/macro";
import {
  type ContractorForNavigationQuery,
  useContractorForNavigationQuery,
} from "@src/__generated__/graphql";
import { useNavigationPages } from "../hooks";
import type { NavigationHook } from "../hooks/types";

export function useContractorsNavigationPages(
  contractorId?: string,
): NavigationHook<ContractorForNavigationQuery["contractor"]> {
  const { data, loading } = useContractorForNavigationQuery({
    variables: {
      id: contractorId ?? "",
    },
    skip: !contractorId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-first",
  });

  const { activePage, activeSubpage, allPages, visiblePages } =
    useNavigationPages([
      {
        href: {
          pathname: "/contractors",
        },
        title: () => t`Contractors`,
      },
    ]);

  return {
    data: data?.contractor,
    isLoading: loading,
    activePage,
    activeSubpage,
    allPages,
    visiblePages,
  };
}
